import { Box, Divider, ITheme, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import NumberInput from '../../common/NumberInput'
import { StageDistribution } from '../../../models/Common'
import { Utilities } from '../../../utility/utils';
import { useTranslation } from 'react-i18next';

export interface IStageSelectorProps {
    onChange: (distrib: StageDistribution) => void;
    defaultValue?: StageDistribution;
}

const StageSelector: React.FC<IStageSelectorProps> = ({ onChange, defaultValue }) => {
    const [distribution, setDistribution] = useState<StageDistribution>(defaultValue ? defaultValue : { early: 0, growth: 0, late: 0 });
    const { t } = useTranslation();
    const theme = useTheme() as ITheme;

    const total = distribution.early + distribution.growth + distribution.late;
    const onDistributionChange = (state: 'early' | 'growth' | 'late', val: number | undefined): void => {
        const distrib = { ...distribution };
        if (val === undefined) {
            distrib[state] = 0;
        } else {
            const subTotal = total - distribution[state];
            if (subTotal + val > 1) {
                distrib[state] = 1 - subTotal;
            } else {
                distrib[state] = val;
            }
        }
        setDistribution(distrib);
        onChange(distrib);
    }

    return <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
        <Typography fontSize={"16px"} fontWeight={"500"} lineHeight={"19.5px"}>{t('CreatePortfolioSelectStageLabel')}</Typography>
        <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"25px"}>{t('PortfolioPageItemStageEarly')}</Typography>
                <Box display={"flex"} gap={"5px"} alignItems={"center"}>
                    <NumberInput placeholder='0' min={0} value={distribution?.early*100 > 0 ? distribution?.early*100 : undefined} onChange={(e, value: number | undefined) => onDistributionChange('early', value ? value/100 : 0)} style={{ maxWidth: "60px", textAlign: "center" }}/>
                    <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"25px"}>%</Typography>
                </Box>
            </Box>
            <Divider />
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"25px"}>{t('PortfolioPageItemStageGrowth')}</Typography>
                <Box display={"flex"} gap={"5px"} alignItems={"center"}>
                    {/* <NumberInput slotProps={{ decrementButton: { hidden: true }, incrementButton: { hidden: true }, input: { style:{ textAlign : "center", width: "100%"}}}} placeholder='0' style={{ maxWidth: "60px" }} value={distribution?.growth*100} onChange={(e, value: number | undefined) => onDistributionChange('growth', value ? value/100 : 0)} /> */}
                    <NumberInput placeholder='0' min={0} value={distribution?.growth*100 > 0 ? distribution?.growth*100 : undefined} onChange={(e, value: number | undefined) => onDistributionChange('growth', value ? value/100 : 0)} style={{ maxWidth: "60px",  textAlign: "center" }} />
                    <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"25px"}>%</Typography>
                </Box>
            </Box>
            <Divider />
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"25px"}>{t('PortfolioPageItemStageLate')}</Typography>
                <Box display={"flex"} gap={"5px"} alignItems={"center"}>
                    {/* <NumberInput slotProps={{ decrementButton: { hidden: true }, incrementButton: { hidden: true }, input: { style:{ textAlign : "center", width: "100%"}}}} placeholder='0' style={{ maxWidth: "60px" }} value={distribution?.late*100} onChange={(e, value: number | undefined) => onDistributionChange('late', value ? value/100 : 0)} /> */}
                    <NumberInput placeholder='0' min={0}  value={distribution?.late*100 ? distribution?.late*100 : undefined} onChange={(e, value: number | undefined) => onDistributionChange('late', value ? value/100 : 0)} style={{ maxWidth: "60px", textAlign: "center" }}/>
                    <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"25px"}>%</Typography>
                </Box>
            </Box>
            <Divider />
            <Box display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
                    <Typography fontSize={"18px"} fontWeight={"600"} lineHeight={"25px"} color={total === 1 ? theme.palette.primary.dark : undefined}>{Utilities.round(total*100, 2)}%</Typography>
                    <Typography fontSize={"10px"} fontWeight={"400"} lineHeight={"25px"}>{Utilities.round((1 - total)*100, 2)}% {t('CreatePortfolioSplitRemaining')}</Typography>
                </Box>
            </Box>
        </Box>
    </Box>
}

export default StageSelector